// extracted by mini-css-extract-plugin
export var errorIcon = "_ky-1";
export var nameLogo = "_ky-0";